import { useAppDispatch, useAppSelector } from 'app/hooks';
import { setConfigurations } from 'features/configurations';
import { useEffect } from 'react';
import { snapWallMountedAirHandlersInConfigurations } from 'utils/snap-wall-mounted-air-handlers';

export default function useSnapWallMountedAirHandlers(): void {
  const dispatch = useAppDispatch();
  const configurations = useAppSelector(
    (state) => state.configurations.configurations
  );
  const structure = useAppSelector((state) => state.structure.structure);
  const configGenerating = useAppSelector((state) => state.ai.configGenerating);
  const activeTab = useAppSelector((state) => state.ui.activeTab);

  useEffect(() => {
    if (activeTab !== 'configurations') return;
    if (configGenerating) return;
    if (structure.length === 0 || configurations.length === 0) return;

    const next = snapWallMountedAirHandlersInConfigurations(
      configurations,
      structure
    );
    if (next) {
      dispatch(setConfigurations(next));
    }
  }, [activeTab, configGenerating, configurations, dispatch, structure]);
}
